var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c(
        "div",
        { staticClass: "block-editor ai-classification payload" },
        [
          _c("strong", [_vm._v("Sınıflandırılacak Ifade: ")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "says" },
            [
              _c("TiptapEditor", {
                key: "tiptap-prompt" + _vm.renderKey,
                attrs: {
                  "show-emoji": true,
                  "show-attributes": true,
                  placeholder:
                    "Kullanıcı mesajı veya sınıflandırma yapılacak metni giriniz",
                },
                model: {
                  value: _vm.clone.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "message", $$v)
                  },
                  expression: "clone.message",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("strong", [_vm._v("Sınıflandırma:")]),
          _vm._v(" "),
          _vm._l(_vm.clone.tags, function (tag, i) {
            return _c(
              "div",
              { key: tag, staticClass: "says" },
              [
                _c("TiptapEditor", {
                  key: "tiptap-tag" + tag + _vm.renderKey,
                  attrs: {
                    "show-emoji": true,
                    "show-attributes": true,
                    placeholder: "Sınıflandırma",
                  },
                  model: {
                    value: _vm.clone.tags[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.tags, i, $$v)
                    },
                    expression: "clone.tags[i]",
                  },
                }),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { danger: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeTag(i)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.addTag } },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(" Sınıflandırma Ekle"),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }